module.exports = __webpack_public_path__ + "static/dark-green-wave-892ccc728e71333f140eed47aeb9f026.png";